<template>
	<div id="unit_convertor">
		<h3>Unit Convertor</h3>
		<b-form-select v-model="area">
          <!-- <template slot="first">
            <option :value="null" disabled="">Select a tag</option>
          </template> -->
		      <option v-for="area in areas" :value="area">{{capitalize(area)}}
          </option>
		</b-form-select>

		<div class="wrapper">
			<div class="material-section">
				<div class="entry">
					<input class="value" v-model="convertFrom" placeholder="From" type="text" min="0" step="0.01"/>
					
				</div>
				<div class="selections">
					<b-form-select v-model="selected_possibility">
			          <!-- <template slot="first">
			            <option :value="null" disabled="">Select a tag</option>
			          </template> -->
					      <option v-for="poss in possibilities" :value="poss">{{poss}}
			          </option>
					</b-form-select>
				</div>
			</div>
			<div class="middle">
				<span>=</span>
			</div>
			<div class="material-section">
				<div class="entry">
					<input class="value" v-model="convertTo" disabled placeholder="To" type="text" min="0" step="0.01"/>
					
				</div>
				<div class="selections">
					<b-form-select v-model="selected_possibility2">
			          <!-- <template slot="first">
			            <option :value="null" disabled="">Select a tag</option>
			          </template> -->
					      <option v-for="poss in possibilities" :value="poss">{{poss}}
			          </option>
					</b-form-select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var convert = require('convert-units');

export default {
	name:'UnitConvertor',
	data: function() {
		return {
			area:'length',
			selected_possibility:'',
			selected_possibility2:'',
			convertFrom:0
		}
	},
	mounted() {
		console.log(convert(1).from('l').to('ml'));
	},
	computed: {
		areas: function() {
			return convert().measures();
		},
		possibilities: function() {
			return convert().possibilities(this.area);
		},
		convertTo: function() {
			let p = 0;
			if(this.selected_possibility != '' && this.selected_possibility2 != '') {
				p = convert(this.convertFrom).from(this.selected_possibility).to(this.selected_possibility2);
			}
		
			return p;
		}

	},
	methods: {
		capitalize(s) {
	      return s.charAt(0).toUpperCase() + s.slice(1);
	    },	
	},
	watch: {
		area: function() {

			this.selected_possibility = this.possibilities[0];
			this.selected_possibility2 = this.possibilities[1];
		}
	}
	
}
</script>

<style scoped>
.wrapper {
	margin-top: 20px;
	
}

.middle span {
	font-size: 2.6rem;
	width: 100%;
	text-align: center;
	display: block
}
.entry .value {
	width: 100%;
	font-size: 1.6rem;
	padding: 20px;
	background-color: #262f3c;
	border:none;
	border-radius: 5px;
	color:white;
}

@media screen and (min-width: 1024px) {
	.wrapper {
		display: flex;
		align-items: center;
	}
	.material-section {
		flex-basis: 40%;
	}
	.middle {
		flex-basis: 20%;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/UnitConvertor.vue